import React from "react";
import SampleReportPdfPreviewLayout from "../layouts/sampleReportPdfPreviewLayout";

const SampleReportPdfPreview = React.lazy(() => import("../pages/sampleReportpdfViewer/sampleReportpdfPreviewPage"))

/**
 * Array of route objects defining the routes for the sample-report preview pages.
 */
export const sampleReportPdfRoutes = [
  {
    path: "", // The base path for the sample-report preview routes
    element: <SampleReportPdfPreviewLayout />,
    children: [
      {
        path: "followups/report/preview",
        element: <SampleReportPdfPreview />
      },
    ],
  },
];
